import React from "react";

const EmailIcon = ({ width }) => {
  return (
    <svg
      width={width}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <path
          style={{ fill: "#E2E7F0" }}
          d='M192,320h128l120-100V32c0-17.672-14.328-32-32-32H104C86.328,0,72,14.328,72,32v188L192,320z'
        ></path>{" "}
        <g>
          {" "}
          <polygon
            style={{ fill: "#F19920" }}
            points='440,115.04 440,220 512,160 '
          ></polygon>{" "}
          <polygon
            style={{ fill: "#F19920" }}
            points='72,115.04 0,160 72,220 '
          ></polygon>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#9DACBA" }}
            d='M192,48h128c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H192c-4.416,0-8-3.584-8-8l0,0 C184,51.584,187.584,48,192,48z'
          ></path>{" "}
          <path
            style={{ fill: "#9DACBA" }}
            d='M144,112h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,115.584,139.584,112,144,112z'
          ></path>{" "}
          <path
            style={{ fill: "#9DACBA" }}
            d='M144,160h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,163.584,139.584,160,144,160z'
          ></path>{" "}
          <path
            style={{ fill: "#9DACBA" }}
            d='M144,208h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,211.584,139.584,208,144,208z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <polygon
            style={{ fill: "#E78825" }}
            points='56,206.64 72,220 72,115.04 56,125.04 '
          ></polygon>{" "}
          <polygon
            style={{ fill: "#E78825" }}
            points='456,206.64 440,220 440,115.04 456,125.04 '
          ></polygon>{" "}
        </g>{" "}
        <path
          style={{ fill: "#F6B545" }}
          d='M192,320L9.44,502.56C3.432,496.584,0.032,488.472,0,480V160L192,320z'
        ></path>{" "}
        <path
          style={{ fill: "#FCD063" }}
          d='M502.56,502.56c-5.976,6.008-14.088,9.408-22.56,9.44H32c-8.472-0.032-16.584-3.432-22.56-9.44 L192,320h128L502.56,502.56z'
        ></path>{" "}
        <path
          style={{ fill: "#F6B545" }}
          d='M512,480c-0.032,8.472-3.432,16.584-9.44,22.56L320,320l192-160V480z'
        ></path>{" "}
        <path
          style={{ fill: "#C9D5E3" }}
          d='M192,320h128l117.6-98c-4.816-7.408-14.72-9.52-22.136-4.704c-0.448,0.296-0.888,0.608-1.304,0.944 L336,284c-15.408,12.952-34.904,20.04-55.04,20h-55.04c-14.032,0.088-27.808,3.776-40,10.72L192,320z'
        ></path>{" "}
        <path
          style={{ fill: "#F19920" }}
          d='M496,200v280c0,8.84-7.16,16-16,16H48c-8.84,0-16,7.16-16,16h448c17.672,0,32-14.328,32-32V184l0,0 C503.16,184,496,191.16,496,200z'
        ></path>{" "}
        <path
          style={{ fill: "#F6B545" }}
          d='M491.28,491.28c-2.984,3.008-7.04,4.704-11.28,4.72H48c-8.84,0-16,7.16-16,16h448 c8.472-0.032,16.584-3.432,22.56-9.44L491.28,491.28z'
        ></path>{" "}
      </g>
    </svg>
  );
};

export default EmailIcon;
